var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tabbar[data-v-c157320c]{position:fixed;bottom:0;left:0;width:100%;height:50px;background-color:#f2f2f2;font-weight:700}.tabbar-div[data-v-c157320c]{width:24%;height:50px;padding-top:10px;text-align:center;float:left;font-size:12px;font-family:PingFangSC-Regular;src:url(" + escape(require("../../static/css/PingFangRegular.ttf")) + ")}.tabbar-div-on[data-v-c157320c]{font-size:14px;color:#6495ed!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c157320c","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FooterCpt.vue
// module id = mgfO
// module chunks = 1